import Vue from 'vue'
import Vuex from 'vuex'

import app from '../main'
import menu from './modules/menu'

Vue.use(Vuex)

export const store = new Vuex.Store({
  state: {
    accessToken:null,
    currentUser:null,
    droppedFiles:{
      patient:[],
      rdv:[]
    },
    isUploadTab:false
  },
  getters: {
    getDroppedFilesByType: (state) => (type) => {
      return state.droppedFiles[type]
    }
  },
  mutations: {
    changeLang (state, payload) {
      app.$i18n.locale = payload
      localStorage.setItem('currentLanguage', payload)
    }
  },
  actions: {
    setLang ({ commit }, payload) {
      commit('changeLang', payload)
    }
  },
  modules: {
    menu  
  }
})
